<template >
<div id="home" class="intro route">
    <div class="overlay-itro" />
    <div class="intro-content display-table">
      <div class="table-cell">
        <main role="main" class="container">
                <h1 class="heading-primary-main mb-4">Rkr Shen</h1>
                <p class="heading-primary-sub">FULL STACK FRONTEND DEVELOPER</p>
        </main>
      </div>
    </div>
</div>
</template>



<script >
	export default {
    components: {
        },

		computed: {
			total() {
				return this.$store.getters.total;
			}
		}
	}
</script>



<style >
.intro {
  height: 100vh;
  position: relative;
}

.intro .intro-content {
  text-align: center;
  position: absolute;
}

.intro .overlay-itro {
  position: absolute;
  top: 0;
  left: 0px;
  padding: 0;
  height: 100%;
  width: 100%;
}

.display-table {
  width: 100%;
  height: 100%;
  display: table;
}

.table-cell {
  display: table-cell;
  vertical-align: middle;
  transform: translateY(-10%);
}

.heading-primary-main {
  font-weight: 600;
  font-size: 3rem;
  animation-name: moveInleft;
  animation-duration: 2s;
  color: black;
  font-family:comfortaa;
  margin-top: 0;
  }

.heading-primary-sub {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Arial;
  margin-top: 10px;
  animation-name: moveInright;
  animation-duration: 2s;
  color: black; }

@keyframes moveInleft {
  0% {
    opacity: 0;
    transform: translateX(-20px); }
  80% { }
  100% {
    opacity: 1;
    transform: translate(0); } }

@keyframes moveInright {
  0% {
    opacity: 0;
    transform: translateX(20px); }
  80% { }
  100% {
    opacity: 1;
    transform: translate(0); } }


    
</style>


// WEBPACK FOOTER //
// src/components/Home.vue